/**
 * Created by Ivan on 20.06.2026
 */

const LorysDerby = function (mission) {
    cleverapps.EventEmitter.call(this);
    this.mission = mission;
    const data = this.mission && this.mission.details || {};
    this.level = data && data.level || 0;
    this.stage = data && data.stage || 0;
    this.unlocked = data && data.unlocked || false;
    this.stages = this.mission.stages;
    this.regularStagesCount = this.stages.filter((stage) => !stage.extra).length;
    this.countDown = new cleverapps.CountDown(this.getTimeLeft(), {
        permanent: true,
        onFinish: this.onTimeout.bind(this)
    });

    if (this.stage >= this.stages.length) {
        this.mission.complete();
    } else if (this.unlocked && this.getTimeLeft() === 0) {
        this.mission.complete();
    }

    if (this.mission.isRunning()) {
        this.mission.logEvent(Mission.EVENTS.MISSION_STAGE, { itemId: `${this.stage}`, once: true });
    }
};

LorysDerby.prototype = Object.create(cleverapps.EventEmitter.prototype);
LorysDerby.prototype.constructor = LorysDerby;

LorysDerby.prototype.getView = function () {
    return this.unlocked ? LorysDerbyWindow : LorysDerbyStartWindow;
};

LorysDerby.prototype.getFinishWindow = function () {
    return this.unlocked ? LorysDerbyFinishWindow : undefined;
};

LorysDerby.prototype.isUnlocked = function () {
    return this.unlocked;
};

LorysDerby.prototype.startCompetition = function () {
    if (this.unlocked) {
        return;
    }

    this.unlocked = true;
    this.update();
    this.mission.logEvent(Mission.EVENTS.MISSION_UNLOCKED);
};

LorysDerby.prototype.getTimeLeft = function () {
    return this.mission.getTimeLeft();
};

LorysDerby.prototype.onTimeout = function () {
    this.trigger("timeout");

    if (this.unlocked && !this.isAllStagesCompleted()) {
        this.mission.complete();
    }
};

LorysDerby.prototype.isAttentionRequired = function () {
    return this.isStageCompleted();
};

LorysDerby.prototype.isLastStage = function (stage) {
    return stage === this.stages.length - 1;
};

LorysDerby.prototype.getStageRewards = function () {
    return this.stages.map((stage) => this.getStageReward(stage));
};

LorysDerby.prototype.getCurrentReward = function () {
    const stage = this.getCurrentStage();

    return this.getStageReward(stage);
};

LorysDerby.prototype.getStageReward = function (stage) {
    return new RewardsList(stage.prize, {
        event: cleverapps.EVENTS.LORYS_DERBY.EARN,
        toBubbleStack: true
    });
};

LorysDerby.prototype.getCurrentStage = function () {
    return this.getStage(this.stage);
};

LorysDerby.prototype.getStage = function (stage) {
    return this.stages[stage];
};

LorysDerby.prototype.getMaxStage = function () {
    return this.stages.length - 1;
};

LorysDerby.prototype.setLevel = function (level) {
    if (this.level !== level) {
        this.level = level;
        this.trigger("updateLevel");
    }
};

LorysDerby.prototype.updateStage = function () {
    this.level -= this.getCurrentStage().goal;
    this.stage += 1;
    this.mission.logEvent(Mission.EVENTS.MISSION_STAGE, { itemId: `${this.stage}` });

    if (this.stage >= this.stages.length) {
        this.mission.logEvent(Mission.EVENTS.MISSION_FINISH, { once: true });
        this.mission.complete();
    } else {
        this.trigger("updateStage");
        cleverapps.metrics.logEvent(`${cleverapps.EVENTS.LORYS_DERBY.STAGE}${this.stage}`);
    }

    this.update();
};

LorysDerby.prototype.isStageCompleted = function () {
    const stage = this.getCurrentStage();
    if (!stage) {
        return false;
    }

    return this.level >= stage.goal;
};

LorysDerby.prototype.isAllStagesCompleted = function () {
    return this.stage >= this.stages.length;
};

LorysDerby.prototype.isExtraChallenge = function () {
    const stage = this.getCurrentStage();
    return Boolean(stage && stage.extra);
};

LorysDerby.prototype.getProgress = function (effective) {
    let stage = this.stage;
    let level = this.level;

    if (effective) {
        while (this.stages[stage] && level >= this.stages[stage].goal) {
            level -= this.stages[stage].goal;
            stage += 1;
        }
    }

    return { stage, level };
};

LorysDerby.prototype.getProgressReward = function (effective) {
    return this.getStageReward(this.getStage(this.getProgress(effective).stage));
};

LorysDerby.prototype.isWin = function () {
    return this.getProgress(true).stage >= this.regularStagesCount;
};

LorysDerby.prototype.incLevel = function (stars) {
    if (!this.unlocked) {
        return;
    }

    this.mission.logEvent(Mission.EVENTS.MISSION_ACTION, { once: true });

    this.level += stars;
    this.mission.logEvent(Mission.EVENTS.MISSION_POINTS, { value: stars });
    this.trigger("updateLevel", true, stars);
    this.update();
};

LorysDerby.prototype.getInfo = function () {
    return {
        level: this.level,
        stage: this.stage,
        unlocked: this.unlocked
    };
};

LorysDerby.prototype.save = function (details) {
    details.level = this.level;
    details.stage = this.stage;
    details.unlocked = this.unlocked;
};

LorysDerby.prototype.update = function () {
    this.mission.update(0, this.getInfo());
    this.updateIcon();
};

LorysDerby.prototype.skipNext = function () {
    return this.isStageCompleted();
};

LorysDerby.prototype.updateIcon = function () {
    this.mission.updateMissionIcon();
    this.trigger("updateStatus");
};

LorysDerby.prototype.onPressed = function () {
    if (this.isStageCompleted()) {
        cleverapps.missionManager.trigger("clickReceiveButton", this.mission.getType());
        return;
    }

    cleverapps.focusManager.display({
        focus: `${this.mission.name}MissionIconClicked`,
        action: function (f) {
            const ViewClass = this.mission.getViewClass();
            new ViewClass(this.mission);
            cleverapps.focusManager.onceNoWindowsListener = f;
        }.bind(this)
    });
};

LorysDerby.prototype.calcStatusInfo = function () {
    const currentStage = this.getCurrentStage();
    if (!currentStage) {
        return;
    }

    const amount = this.level;
    const target = currentStage.goal;

    return {
        text: `%% ${amount}/${target}`,
        icons: {
            "%%": bundles.reward_icons.frames.order_completion_star_png
        },
        progressBar: { amount, target },
        prize: this.isStageCompleted(),
        animation: this.getIconAnimation()
    };
};

LorysDerby.prototype.getIconAnimation = function (vertical) {
    return (this.isWin() ? "full" : "empty") + (vertical ? "_vert" : "");
};

LorysDerby.prototype.receiveReward = function () {
    if (!this.isStageCompleted()) {
        return;
    }

    let rewards = {};
    while (this.isStageCompleted()) {
        rewards = RewardsList.sumRewards(rewards, this.getCurrentStage().prize);
        this.updateStage();
    }

    return new RewardsList(rewards, {
        event: cleverapps.EVENTS.LORYS_DERBY.EARN,
        toBubbleStack: true
    });
};

LorysDerby.prototype.canRemove = () => true;
LorysDerby.prototype.canRemoveSilently = function () {
    return !this.unlocked;
};
